import { h, RefObject } from 'preact';

export const AssetComponentId = 'studio-asset-component'; // Needed by format for MOAT tracking

interface AssetComponentProps {
  width: string;
  height: string;
  children?: any;
  assetRef?: RefObject<any>;
}

export function AssetComponent({ width, height, children, assetRef }: AssetComponentProps) {
  return (
    <div
      id={AssetComponentId}
      ref={assetRef}
      style={{
        width,
        height,
        flex: '1 1 auto',
        display: 'flex',
        overflow: 'hidden',
        justifyContent: 'space-between',
        maxWidth: '100%',
        minHeight: 0,
        position: 'relative',
      }}
    >
      {children}
    </div>
  );
}
